import { Box } from "@material-ui/core";
import React, { useEffect, useRef, useState } from "react";
import apiUtil from "../../api/apiUtil";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import Table from "../../components/Table/Table";
import "./organization.css";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import edit from "../../images/icons/edit.png";
import delete_icon from "../../images/icons/delete.png";
import CustomButton from "../../components/CustomButton/custombutton";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import CustomInput from "../../components/CustomInput/CustomInput";
import api from "../../api/api";
import getToken from "../getToken";

const Organization = () => {
  const [showAddOrganization, setShowAddOrganization] = useState(false);
  const [showEditOrg, setShowEditOrg] = useState(false);
  const refOrganizationTable = useRef();
  const refPreviewOrganizationFiles = useRef(false);
  const refOrganizationListForm = useRef(null);
  const [detailOrg, setDetailOrg] = useState(null);
  const [keyword, setKeyword] = useState("");

  const clickAddOrg = (e) => {
    e.stopPropagation();
    if (showEditOrg) {
      setShowEditOrg(false);
      setTimeout(() => setShowAddOrganization(true), 100);
    } else {
      setShowAddOrganization(true);
    }
  };
  const clickBtnClose = () => {
    setShowAddOrganization(false);
    setShowEditOrg(false);
  };
  const clickEdit = (rowData) => {
    setDetailOrg({
      id: rowData.id,
      name: rowData.organizationName,
      phone: rowData.phoneNo,
      email: rowData.email,
      orgType: rowData.orgType,
    });
    setShowEditOrg(true);
  };
  const initialValues = {
    name: "",
    phone: "",
    email: "",
    orgType: "",
  };

  const handleDelete = (rowData) => {
    console.log(rowData);
    if (window.confirm("Are you sure you want to delete this organization?")) {
      api
        .delete(`Admin/DeleteOrganization?orgId=${rowData.id}`, getToken())
        .then((result) => {
          apiUtil.parseResult(
            result,
            (response) => {
              if (response.data.code === 401) {
                alert(response.data.message);
                localStorage.removeItem("user");
                window.location.href = "/login";
              } else if (response.data.statusCode === 200) {
                alert("Organization deleted successfully!");
                retrieveOrganizationList();
              } else {
                alert(response.data.message);
              }
            },
            (error) => {
              alert(error);
            }
          );
        });
    }

  };


  const AddOrganizationFormValidation = Yup.object().shape({
    name: Yup.string().nullable().required("Please enter the name."),
    phone: Yup.string()
      .required("Please enter the phone number.")
      .test(
        "phone",
        "Please enter format phone number. For example, 09xxxxxxxxx (or) 018xxxxxx.",
        (val) => /^\d{2,3}\d{7,9}$/g.test(val)
      ),
    orgType: Yup.string().required("Please enter the organization type."),

  });

  const [organizationList, setOrganizationList] = useState({
    isLoading: false,
    grouping: false,
    limit: apiUtil.getDefaultPageSize(),
    data: [],
    total: 0,
    page: 1,
  });

  const [param, setParam] = useState({
    keyword: "",
    rowLimit: 10,
    currentPage: 1,
    sortBy: "",
    isDesc: true
  });

  const retrieveOrganizationList = (value = param) => {
    value.keyword = keyword || "";
    setOrganizationList({
      ...organizationList,
      isLoading: false,
    });

    api.post("Admin/GetOrganizationList", value, getToken())
      .then((result) => {
        apiUtil.parseResult(
          result,
          (response) => {
            if (response.data.code === 401) {
              alert(response.data.message);
              localStorage.removeItem("user");
              window.location.href = "/login";
            }
            if (response.data.code === 200) {
              if (response.data.data.data != null) {
                setOrganizationList({
                  isLoading: false,
                  limit: response.data.data.rowLimit,
                  data:
                    response.data.data.data &&
                      response.data.data.data.length > 0
                      ? response.data.data.data
                      : [],
                  total: response.data.data.data.totalRecords,
                  page: response.data.data.paging,
                });
              }
              else {
                setOrganizationList({
                  isLoading: false,
                  grouping: false,
                  limit: apiUtil.getDefaultPageSize(),
                  data: [],
                  total: 0,
                  page: 0,
                });
              }
            }
          },
          (error, type) => {
            console.log(error);
          }
        );
      });
  };

  const handleSubmitForm = (values, actions) => {
    const payload = {

      organizationName: values.name,
      phoneNo: values.phone,
      email: values.email,
      orgType: values.orgType,
    };

    console.log(payload);

    api.post("Admin/CreateOrganization", payload, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.code === 200) {
            alert("organization saved successfully!!");

            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowAddOrganization(false);

            retrieveOrganizationList();
            for (let i = 0; i < refOrganizationListForm.current.length - 2; i++) {
              refOrganizationListForm.current[i].value = "";
            }
            refPreviewOrganizationFiles.current = false;
            //refresh menu list
            retrieveOrganizationList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };

  const editOrganizationSubmit = (values, actions) => {
    const payload = {
      id: values.id,
      // id: orgId.current,
      organizationName: values.name,
      phoneNo: values.phone,
      email: values.email,
      orgType: values.orgType,
    };
    console.log(payload);
    api.post("Admin/UpdateOrganization", payload, getToken()).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          if (response.data.code === 401) {
            alert(response.data.message);
            localStorage.removeItem("user");
            window.location.href = "/login";
          } else if (response.data.statusCode === 200) {
            alert("organization updated successfully!!");
            // reset the inputs and clear values
            actions.resetForm();
            values = {};
            setShowEditOrg(false);

            retrieveOrganizationList();
            for (let i = 0; i < refOrganizationListForm.current.length - 2; i++) {
              refOrganizationListForm.current[i].value = "";
            }
            refPreviewOrganizationFiles.current = false;
            retrieveOrganizationList(param);
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };


  useEffect(() => {
    retrieveOrganizationList();
  }, [param]);

  return (

    <>
      {(showAddOrganization || showEditOrg) && (
        <>
          <div className="Actions space_between">
            <h6 className="title_text mt-2">Organization</h6>
            <button className="btn btnClose" onClick={clickBtnClose}>
              <img src={close} className="imgClose" alt="imgClose" />
            </button>
          </div>

          <Formik
            initialValues={showEditOrg ? detailOrg : initialValues}

            enableReinitialize={true}
            validateOnBlur={false}
            validationSchema={AddOrganizationFormValidation}
            onSubmit={(values, actions) => {
              showEditOrg
                ? editOrganizationSubmit(values, actions)
                : handleSubmitForm(values, actions);
            }}
          >
            {({ values, errors, touched, setFieldValue }) => (
              <Form
                ref={refOrganizationListForm}
                className="row form-container add-organization-form"
              >
                <div className="col-6 mt-2">
                  <CustomInput
                    name="name"
                    type="text"
                    label="Name"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="Enter Name"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="phone"
                    type="phone"
                    label="Phone Number"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="09-"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="email"
                    type="email"
                    label="Email"
                    customclass="input_wrapper"
                    hideicon="true"
                    placeholder="example@gmail.com"
                  />
                </div>
                <div className="col-6 mt-2">
                  <CustomInput
                    name="orgType"
                    type="text"
                    label="OrganizationType"
                    customclass="input_wrapper"
                    hideicon="true"

                  />
                </div>

                <div className="form-group mt-4">
                  <div className="Actions justify-content-end">
                    <button
                      type="button"
                      className="button btnCancel"
                      onClick={clickBtnClose}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="button btnSave">
                      {showAddOrganization ? "Create" : "Update"}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {/* </div>
            </div>
          </div> */}
        </>
      )}

      <div className="Actions space_between">
        <h6 className="title_text mt-2">Organization</h6>
        <div className="d-flex justify-content-end gap-16 align-items-center">
          {/* <CustomFilter /> */}
          <CustomSearchBar
            value={keyword}
            setValue={setKeyword}
            onSearch={() => retrieveOrganizationList()}
          />
          {!showAddOrganization && (
            <CustomButton
              icon={add}
              text="Add organization"
              addIcon={true}
              className="btnAdd"
              onClick={(e) => clickAddOrg(e)}
            />
          )}
        </div>
      </div>

      <div className="table_container organization_table">
        <Table
          ref={refOrganizationTable}
          maxBodyHeight={organizationList.limit * 100}
          isLoading={organizationList.isLoading}
          grouping={organizationList.grouping}
          limit={organizationList.limit}
          page={organizationList.page}
          total={organizationList.total}
          data={organizationList.data}
          onPageChange={(page) => {
            setParam({
              ...param,
              currentPage: page,
            });
            retrieveOrganizationList(param);
          }}
          columns={[
            {
              title: "No",
              render: (row) => {
                const startingIndex = (organizationList.page - 1) * organizationList.limit + 1;
                return startingIndex + row.tableData.index;
              },
              width: "80px",
              align: "center",
            },

            {
              title: "Name",
              render: (row) => {
                if (row.organizationName == null || row.organizationName == "") {
                  return "Unknown";
                }
                return row.organizationName;
              },
              width: "100px",
            },
            {
              title: "Phone Number",
              field: "phoneNo",
              width: "120px",
            },
            {
              title: "Email",
              field: "email",
              width: "120px",
            },
            {
              title: "Organization Type",
              field: "orgType",
              width: "100px",
              align: "center",
            },

            {
              title: "Edit",
              render: (row) => {
                return (
                  <Box
                    className=" cursor-pointer"
                    onClick={(e) => clickEdit(row)}
                  >
                    <img src={edit} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
            {
              title: "Delete",
              render: (row) => {
                return (
                  <Box
                    style={{ cursor: "pointer" }}
                    onClick={() => handleDelete(row)}
                  >
                    <img src={delete_icon} alt="" className="imgIcon" />
                  </Box>
                );
              },
              align: "center",
              sorting: false,
              width: "80px",
            },
          ]}
        />
      </div>
    </>

  );
};

export default Organization;
